module.exports = __webpack_public_path__ + "static/presidents-message-hero-1920x1080-89b1988e1ac797370c5fd2072f00b6bd.jpg";